import { Control, Controller } from 'react-hook-form';
import { CreateProductFormSchemaType } from '../common';
import { FormLabel } from '../form-label';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { Input } from 'antd';

const ProductMaterialRemark = ({
  control,
}: {
  control: Control<CreateProductFormSchemaType>;
}) => {
  return (
    <div className="flex items-center gap-2">
      <FormLabel>{i18n.t(LOCALS.material_remark)}:</FormLabel>
      <Controller
        name="materialRemark"
        control={control}
        render={({ field }) => (
          <Input.TextArea
            {...field}
            className="w-full"
            placeholder={i18n.t(LOCALS.please_enter) || ''}
          />
        )}
      />
    </div>
  );
};

export default ProductMaterialRemark;
